import {initStore} from './store';

const configureStore = () => {
    const actions = {
        SET_PAYMENT_METHODS_DATA: (curState, paymentMethods) => {
            return {...curState, paymentMethods: paymentMethods};
        },
        SET_SELECTED_PAYMENT_CATEGORY: (curState, selected) => {
            return {...curState, selectedPaymentCategory: selected};
        },
        SET_SELECTED_PAYMENT_METHOD: (curState, selected) => {
            return {...curState, selectedPaymentMethodType: selected};
        }
    };
    initStore(actions);
};

export default configureStore;
